import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-suoxiao2",
  "use": "icon-suoxiao2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-suoxiao2\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 113.810286V0h455.094857v113.810286H194.194286L482.742857 402.285714 402.285714 482.742857 113.810286 194.194286v260.900571H0V113.810286zM1024 910.189714V1024H568.905143v-113.810286h260.900571L541.257143 621.714286l80.457143-80.457143 288.475428 288.548571V568.905143H1024v341.284571z\" fill=\"#68B9FF\" p-id=\"2723\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol